import { DefaultLoader, Engine, ExcaliburGraphicsContext, Scene, SceneActivationContext } from 'excalibur';
import { controller } from '../../shared/controls/controller';
import { leftKeyboard } from '../../shared/controls/leftKeyboard';
import { AutoPaddle } from './AutoPaddle';
import { Ball } from './ball';
import { generateBricks } from './generateBricks';
import { Paddle } from './paddle';

export class BreakoutScene extends Scene {
    private _paddle!: AutoPaddle | Paddle;
    override onInitialize(engine: Engine): void {
        this._paddle = new AutoPaddle(engine);
        this.add(this._paddle);
        this.add(new Ball());
        generateBricks(engine);

        const gamepad = engine.input.gamepads.at(0);
        this._controller = gamepad?.connected ? controller(gamepad) : leftKeyboard(engine.input.keyboard);
    }

    override onPreLoad(loader: DefaultLoader): void {
        // Add any scene specific resources to load
    }

    override onActivate(context: SceneActivationContext<unknown>): void {
        // Called when Excalibur transitions to this scene
        // Only 1 scene is active at a
    }

    override onDeactivate(context: SceneActivationContext): void {
        // Called when Excalibur transitions away from this scene
        // Only 1 scene is active at a time
    }

    private _controller!: ReturnType<typeof controller> | ReturnType<typeof leftKeyboard>;
    override onPreUpdate(engine: Engine, elapsedMs: number): void {
        this._controller.start.pressed && this.switchPaddle(engine);
    }

    private switchPaddle(engine: Engine) {
        if (!(this._paddle instanceof AutoPaddle)) return

        // switch to player paddle
        const position = this._paddle.pos;
        this._paddle.kill();
        this._paddle = new Paddle(engine);
        this._paddle.pos = position;
        this.add(this._paddle);
    }

    public reset() {
        // reset the game to auto paddle
        this.clear();
        this._paddle.kill();
        this._paddle = new AutoPaddle(this.engine);
        this.add(this._paddle);
        this.add(new Ball());
        generateBricks(this.engine);
    }

    override onPostUpdate(engine: Engine, elapsedMs: number): void {
        // Called after everything updates in the scene
    }

    override onPreDraw(ctx: ExcaliburGraphicsContext, elapsedMs: number): void {
        // Called before Excalibur draws to the screen
    }

    override onPostDraw(ctx: ExcaliburGraphicsContext, elapsedMs: number): void {
        // Called after Excalibur draws to the screen
    }
}
